import React from 'react';

const Table = ({ ...attrs }) => (
  <svg viewBox="0 0 32 32" {...attrs}>
    <path
      d="m 8.8771269,7.68 0,3.84 -8.2371269,0 0,-3.84 z M 1.92,8.96 l 0,1.28 5.6771269,0 0,-1.28 z m 6.9571269,5.12 0,3.84 -8.2371269,0 0,-3.84 z M 1.92,15.36 l 0,1.28 5.6771269,0 0,-1.28 z m 6.9571269,5.12 0,3.84 -8.2371269,0 0,-3.84 z M 1.92,23.04 l 5.6771269,0 0,-1.28 -5.6771269,0 z"
      id="path6"
    />
    <path
      d="m 20.070623,7.702163 0,3.84 -8.237127,0 0,-3.84 z m -6.957127,1.28 0,1.28 5.677127,0 0,-1.28 z m 6.957127,5.12 0,3.84 -8.237127,0 0,-3.84 z m -6.957127,1.28 0,1.28 5.677127,0 0,-1.28 z m 6.957127,5.12 0,3.84 -8.237127,0 0,-3.84 z m -6.957127,2.56 5.677127,0 0,-1.28 -5.677127,0 z"
      id="path6-5"
    />
    <path
      d="m 31.475915,7.7155381 0,3.8399999 -8.237127,0 0,-3.8399999 z m -6.957127,1.28 0,1.2799999 5.677127,0 0,-1.2799999 z m 6.957127,5.1199999 0,3.84 -8.237127,0 0,-3.84 z m -6.957127,1.28 0,1.28 5.677127,0 0,-1.28 z m 6.957127,5.12 0,3.84 -8.237127,0 0,-3.84 z m -6.957127,2.56 5.677127,0 0,-1.28 -5.677127,0 z"
      id="path6-5-8"
    />
  </svg>
);

export default Table;
